import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";

export default function ConfirmDeleteModal(props) {
  const { onConfirm, onHide, ...rest } = props;

  return (
    <Modal {...rest} size="md" centered >
      <Modal.Body>
        <div className="px-3 py-4">
          {props?.productQty > 0 ? (
            <div>
              <div>
                <div className="text-center fs-22 tc-7 mb-2">
                  ขออภัยไม่สามารถลบได้
                </div>
                <div className="text-center fs-22 tc-7">
                  เนื่องจากมีสินค้าที่ใช้งานหมายเหตุนี้อยู่
                </div>
              </div>
              <div className="text-center pt-4 mt-3  btn-group-control">
                <Button
                  type="button"
                  className="btn-st-3 mx-3 "
                  style={{ width: "100px" }}
                  onClick={onHide}
                >
                  ตกลง
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <div>
                <div className="text-center fs-22 tc-7 mb-2">คุณต้องการลบ</div>
                <div className="text-center fs-22 tc-7">
                  ตัวเลือกหมายเหตุนี้ใช่หรือไม่
                </div>
              </div>

              <div className="text-center pt-4 mt-3  btn-group-control">
                <Button
                  type="button"
                  className="btn-st-3 mx-3  "
                  style={{ width: "100px" }}
                  onClick={onConfirm}
                >
                  ใช่
                </Button>
                <Button
                  type="button"
                  className="btn-st-6 mx-3 "
                  style={{ width: "100px" }}
                  onClick={onHide}
                >
                  ไม่ใช่
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
